import React from 'react'
import USDefaultTemplate from 'src/components/template/us'

export default (props) => {
  return (
    <USDefaultTemplate
      location={props.location}
      video={'https://assets.fubo.tv/marketing/lp/videos/compressed/NFLNetworkTrainingCamp2021.mp4'}
      title="Watch NFL Training Camp on NFL Network with Fubo"
      subtitle="In-depth coverage, interviews and more for all 32 teams"
      networkSet="nfl"
      // Remove cable references
      removeCable={true}
      showRedzone={false}
    />
  )
}
